import type { SelectOption } from '@wix/cli-ui-kit';
import {
  EmbedCategory,
  EmbeddedScriptPlacement,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { createI18nT } from '../../../i18n.js';

const t = createI18nT();

export type ValidScriptTypes =
  | EmbedCategory.ESSENTIAL
  | EmbedCategory.FUNCTIONAL
  | EmbedCategory.ANALYTICS
  | EmbedCategory.ADVERTISING;

export type ValidScriptPlacements =
  | EmbeddedScriptPlacement.HEAD
  | EmbeddedScriptPlacement.BODY_START
  | EmbeddedScriptPlacement.BODY_END;

export const SCRIPT_TYPES: Array<SelectOption<ValidScriptTypes>> = [
  {
    title: t('embedded_script.type.essential'),
    description: t('embedded_script.type.essential.description'),
    value: EmbedCategory.ESSENTIAL,
  },
  {
    title: t('embedded_script.type.functional'),
    description: t('embedded_script.type.functional.description'),
    value: EmbedCategory.FUNCTIONAL,
  },
  {
    title: t('embedded_script.type.analytics'),
    description: t('embedded_script.type.analytics.description'),
    value: EmbedCategory.ANALYTICS,
  },
  {
    title: t('embedded_script.type.advertising'),
    description: t('embedded_script.type.advertising.description'),
    value: EmbedCategory.ADVERTISING,
  },
];

export const SCRIPT_PLACEMENTS: Array<SelectOption<ValidScriptPlacements>> = [
  {
    title: t('embedded_script.placement.head'),
    description: t('embedded_script.placement.head.description'),
    value: EmbeddedScriptPlacement.HEAD,
  },
  {
    title: t('embedded_script.placement.body_start'),
    description: t('embedded_script.placement.body_start.description'),
    value: EmbeddedScriptPlacement.BODY_START,
  },
  {
    title: t('embedded_script.placement.body_end'),
    description: t('embedded_script.placement.body_end.description'),
    value: EmbeddedScriptPlacement.BODY_END,
  },
];
